import {UAParser} from "ua-parser-js/src/ua-parser";
function getViewInfo() {
	let result = new UAParser().getResult();
	let infomation = {
		$os: result.os.name || "",
		$os_version: result.os.version || "",
		$manufacturer: result.device.vendor || "",
		$model: result.device.model || "",
		$browser: result.browser.name || "",
		$browser_version: result.browser.version || "",
		$language: getLanguage(),
		$platform: checkPlatform(result.ua.toLowerCase()),
		$engine: result.engine.name,
		$browser_language: navigator.language || navigator.userLanguage || ""
	};
	try {
		infomation.$referrer_host = infomation.$referrer.match(/[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/)[0];
	} catch (e) {
		infomation.$referrer_host = "";
	}
	check360Browser(infomation);
	return infomation;

}

function check360Browser(info) {
	if (!navigator.mimeTypes) return;

	var is360 = false,
		ua = navigator.userAgent,
		_mime = function _mime(option, value) {
			var mimeTypes = navigator.mimeTypes;

			for (var mt in mimeTypes) {
				if (mimeTypes[mt][option] == value) {
					return true;
				}
			}
			return false;
		};

	if (!window.chrome) return;
	var chrome_version = ua.replace(/^.*Chrome\/([\d]+).*$/, "$1");

	if (_mime("type", "application/360softmgrplugin") || _mime("type", "application/mozilla-npqihooquicklogin")) {
		is360 = true;
	} else if (chrome_version > 36 && window.showModalDialog) {
		is360 = true;
	} else if (chrome_version > 45) {
		is360 = _mime("type", "application/vnd.chromium.remoting-viewer");

		if (!is360 && chrome_version >= 69) {
			is360 = _mime("type", "application/hwepass2001.installepass2001") || _mime("type", "application/asx");
		}
	}
	if (is360) {
		if (_mime("type", "application/gameplugin") || (navigator && typeof navigator["connection"] !== "undefined" && typeof navigator["connection"]["saveData"] == "undefined")) {
			var hash = {"86": "13.0",
					"78": "12.0",
					"69": "11.0",
					"63": "10.0",
					"55": "9.1",
					"45": "8.1",
					"42": "8.0",
					"31": "7.0",
					"21": "6.3"
				}, version = ua.replace(/^.*Chrome\/([\d]+).*$/, "$1");
			info.$browser = "360SE";
			info.$browser_version = hash[version] || "";
		} else {
			var hash2 = {
					"95":"21.0",
					"86": "13.0",
					"78": "12.0",
					"69": "11.0",
					"63": "9.5",
					"55": "9.0",
					"50": "8.7",
					"30": "7.5"
				},
				version2 = ua.replace(/^.*Chrome\/([\d]+).*$/, "$1");
			info.$browser = "360EE";
			info.$browser_version = hash2[version2];
		}
	}
}


function getLanguage() {
	var g = (navigator.browserLanguage || navigator.language);
	var arr = g.split("-");
	if (arr[1]) {
		arr[1] = arr[1].toUpperCase();
	}
	return arr.join("_");
}

function checkPlatform(ua) {
	if (isWechat(ua)) {
		return "wechat";
	}
	if (isPC(ua)) {
		return "pc_web";
	}
	if (isTablet(ua)) {
		return "tablet";
	}
	if (isMobile(ua)) {
		return "mobile";
	}

	return "";
}

function isPC(ua) {
	if (ua.match(/linux|windows (nt|98)|macintosh|cros/) && !ua.match(/android|mobile|polaris|lgtelecom|uzard|natebrowser|ktf;|skt;/)) {
		return true;
	}
	return false;
}

function isTablet(ua) {
	if (ua.match(/ipad/) || (ua.match(/android/) && !ua.match(/mobi|mini|fennec/)) ||
		(ua.match(/macintosh/) && window.navigator.maxTouchPoints > 1)) {
		return true;
	}
	return false;
}

function isMobile(ua) {
	if (ua.match(/ip(hone|od)|android.+mobile|windows (ce|phone)|blackberry|bb10|symbian|webos|firefox.+fennec|opera m(ob|in)i|tizen.+mobile|polaris|iemobile|lgtelecom|nokia|sonyericsson|dolfin|uzard|natebrowser|ktf;|skt;/)) {
		return true;
	} else {
		return false;
	}
}

function isWechat(ua) {
	return /MicroMessenger/i.test(ua);
}


export {getViewInfo,};
